import {Injectable} from '@angular/core';
import {WelfareProject} from '../class/welfare-project';
import {Person} from '../class/person';
import {Asset} from '../class/asset';
import {Debt} from '../class/debt';
import {Desktop} from '../class/desktop';
import {LifeProject} from '../class/lifeproject/life-project';
import {Configuration} from '../class/config/configuration';
import {WelfareProjectResult} from '../class/result/welfare-project-result';
import {AssetResource} from '../class/lifeproject/asset-resource';
import {NbDialogService} from '@nebular/theme';
import {UniversityPlan} from '../class/config/university-plan';

@Injectable({
  providedIn: 'root'
})
export class WelfareResultService {

  welfare: WelfareProject;
  private configuration: Configuration;
  private _universityPlan: UniversityPlan[];

  constructor(private dialogService: NbDialogService) {
    this.welfare = new WelfareProject();
  }

  get welfareProject() {
    return this.welfare;
  }

  set welfareProject(welfareProject: WelfareProject) {
    this.welfare = welfareProject;
  }

  get persons() {
    return this.welfareProject.people;
  }

  get assets() {
    return this.welfareProject.assets;
  }

  get debt() {
    return this.welfareProject.debts;
  }

  get lifeProjects() {
    return this.welfareProject.lifeProjects;
  }

  get desktop() {
    return this.welfareProject.desktop;
  }

  set desktop(desktop: Desktop) {
    this.welfareProject.desktop = desktop;
  }

  get config() {
    return this.configuration;
  }

  set config(value: Configuration) {
    this.configuration = value;
  }

  get universityPlans() {
    this.initUniPlans();
    return this._universityPlan;
  }

  get projectResult(): WelfareProjectResult {
    return this.welfareProject.welfareProjectResult;
  }

  set projectResult(value: WelfareProjectResult) {
    this.welfareProject.welfareProjectResult = value;
  }

  addPerson(person?: Person) {
    if (!person) {
      // create person
      person = new Person();
    }

    // push person
    this.welfareProject.people.push(person);
  }

  removeFamilyMember(person: Person) {

    if (person) {

      // find object index
      const index: number = this.welfareProject.people.indexOf(person);

      if (index !== -1) {
        // delete entry
        this.welfareProject.people.splice(index, 1);
      }
    }
  }

  addDebt(debt: Debt) {
    if (debt) {

      if (!this.welfareProject.debts) {
        this.welfareProject.debts = [];
      }

      this.welfareProject.debts.push(debt);
    }
  }

  removeDebt(debt: Debt) {
    if (debt) {
      const index: number = this.welfareProject.debts.indexOf(debt);

      if (index !== -1) {
        this.welfareProject.debts.splice(index, 1);
      }
    }
  }

  addAsset(asset: Asset) {
    if (asset) {
      this.welfareProject.assets.push(asset);
    }
  }

  removeAsset(asset: Asset) {
    if (asset) {

      // get assets index
      const index: number = this.welfareProject.assets.indexOf(asset);

      if (index !== -1) {
        this.welfareProject.assets.splice(index, 1);
      }
    }
  }

  removeLifeProject(lifeProject: LifeProject) {
    if (lifeProject) {

      // check if lifeproject has a asset resource
      if (lifeProject.assets.length) {
        lifeProject.assets.forEach(value => {
          this.subtractAssetUsedValue(value);
        });
      }

      const index: number = this.welfareProject.lifeProjects.indexOf(lifeProject);

      if (index !== -1) {
        this.welfareProject.lifeProjects.splice(index, 1);
      }
    }
  }

  subtractAssetUsedValue(resAsset: AssetResource) {
    if (resAsset) {
      this.assets.forEach(value => {
        if (value.name === resAsset.asset.name && value.kind) {
          value.usedValue -= resAsset.selectedValue;

          if (value.usedValue < 0) {
            value.usedValue = 0;
          }
        }
      });
    }
  }

  restoreUsedAssetValue(resAsset: AssetResource) {
    if (resAsset) {
      this.assets.forEach(value => {
        if (value.name === resAsset.asset.name && value.kind) {
          value.usedValue += resAsset.selectedValue;
        }
      });
    }
  }

  setIsSingle(value: boolean) {
    this.welfareProject.single = value;
  }

  isSingle() {
    return this.welfareProject.single;
  }


  saveProjectLocally() {

    // set local copy
    this.welfareProject.localCopy = true;

    // serialize project
    const json = JSON.stringify(this.welfareProject);

    // save project in local storage
    localStorage.setItem('project_' + this.welfareProject.name, json);
  }

  private initUniPlans() {
    if (!this._universityPlan) {
      this._universityPlan = [
        {
          description: 'Università vicino alla residenza',
          value: 0,
          currency: 30000
        },
        {
          description: 'Università fuori residenza',
          value: 1,
          currency: 50000
        },
        {
          description: 'Master',
          value: 2,
          currency: 70000
        },
        {
          description: 'Altro',
          value: 3,
          currency: 0
        },
      ];
    }

  }

}
